// import { addItemToArray } from 'app/ReducerHelpers';

export const fetchRecords = async () => {
    return new Promise((resolve) => {
        resolve('Not implemented');
    });
};

export const fetch = async () => {
    return new Promise((resolve) => {
        resolve('Not implemented');
    });
};

export const add = async () => {
    return new Promise((resolve) => {
        resolve('Not implemented');
    });
};

export const update = async () => {
    return new Promise((resolve) => {
        resolve('Not implemented');
    });
};

export const deleteRecord = async () => {
    return new Promise((resolve) => {
        resolve('Not implemented');
    });
};

export const clearPreferences = async () => {
    return new Promise((resolve) => {
        resolve('Not implemented');
    });
};
